var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleThumbUp21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_10055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.16699 8V12H4.83366V8H6.16699ZM7.50033 12C7.32351 12 7.15395 11.9298 7.02892 11.8047C6.9039 11.6797 6.83366 11.5101 6.83366 11.3333V8C6.83366 7.81667 6.90699 7.65 7.03033 7.53L9.22366 5.33333L9.57699 5.68667C9.66699 5.77667 9.72366 5.9 9.72366 6.04L9.71366 6.14333L9.39699 7.66667H11.5003C11.8703 7.66667 12.167 7.96667 12.167 8.33333V9C12.167 9.08667 12.1503 9.16667 12.1203 9.24333L11.1137 11.5933C11.0137 11.8333 10.777 12 10.5003 12H7.50033ZM7.50033 11.3333H10.5103L11.5003 9V8.33333H8.57366L8.95033 6.56L7.50033 8.01V11.3333Z",
    fill: "currentColor"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2_10055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.16699 3V7H0.833659V3H2.16699ZM3.50033 7C3.32351 7 3.15395 6.92976 3.02892 6.80474C2.9039 6.67971 2.83366 6.51014 2.83366 6.33333V3C2.83366 2.81667 2.90699 2.65 3.03033 2.53L5.22366 0.333334L5.57699 0.686667C5.66699 0.776667 5.72366 0.900001 5.72366 1.04L5.71366 1.14333L5.39699 2.66667H7.50033C7.87033 2.66667 8.16699 2.96667 8.16699 3.33333V4C8.16699 4.08667 8.15033 4.16667 8.12033 4.24333L7.11366 6.59333C7.01366 6.83333 6.77699 7 6.50033 7H3.50033ZM3.50033 6.33333H6.51033L7.50033 4V3.33333H4.57366L4.95033 1.56L3.50033 3.01V6.33333Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_10055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "currentColor",
    transform: "matrix(-1 0 0 -1 12.5 13)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2_10055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "currentColor",
    transform: "matrix(-1 0 0 -1 8.5 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleThumbUp21);
export default __webpack_public_path__ + "static/media/double-thumb-up-21.c45bac31.svg";
export { ForwardRef as ReactComponent };